import React, { useState } from "react";
import styles from "./styles.css";
import NameIcon from "./images/name-icon.png";
import EmailIcon from "./images/email-icon.png";
import PropTypes from "prop-types";
import EditProfileModal from "../../shared/edit-profile-modal/component";

const MyAccountContent = (props) => {
    const {
        profileName, email, mobile, secureToken, primaryIdentifierType,
        phoneNumberVerified, emailVerified,
        setProfileNameConnect, setEmailConnect, setProfileMobileConnect
    } = props;
    const [showEditModal, setShowEditModal] = useState(false);

    return (
        <div styleName={"styles.wrapper"}>
            <h3 styleName={"styles.heading"}>Basic Details</h3>
            <div styleName={"styles.tabWrap"}>
                <p styleName={"styles.name"}><img src={NameIcon} alt="Name" />Name</p>
                <p styleName={"styles.customerName"}>{profileName || "Not set"}</p>
            </div>
            <div styleName={"styles.tabWrap"}>
                <p styleName={"styles.name"}><img src={EmailIcon} alt="Email" />E-mail</p>
                <p styleName={"styles.customerName"}>{email || "Not set"}</p>
            </div>
            <div styleName={"styles.tabWrap"}>
                <p styleName={"styles.name"}><img src={NameIcon} alt="Phone" />Phone</p>
                <p styleName={"styles.customerName"}>{mobile || "Not set"}</p>
            </div>
            <p styleName={"styles.editProfileLink"} onClick={() => setShowEditModal(true)}>
                Edit Profile
            </p>
            <EditProfileModal
                isOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                profileName={profileName}
                email={email}
                mobile={mobile}
                primaryIdentifierType={primaryIdentifierType}
                phoneNumberVerified={phoneNumberVerified}
                emailVerified={emailVerified}
                secureToken={secureToken}
                setProfileNameConnect={setProfileNameConnect}
                setEmailConnect={setEmailConnect}
                setProfileMobileConnect={setProfileMobileConnect}
            />
        </div>
    );
};

MyAccountContent.propTypes = {
    profileName: PropTypes.string,
    email: PropTypes.string,
    mobile: PropTypes.string,
    secureToken: PropTypes.string,
    primaryIdentifierType: PropTypes.string,
    phoneNumberVerified: PropTypes.bool,
    emailVerified: PropTypes.bool,
    setProfileNameConnect: PropTypes.func,
    setEmailConnect: PropTypes.func,
    setProfileMobileConnect: PropTypes.func
};

export default MyAccountContent;
